export const mdata = [{
    img: 'image1.png',
    title: '拼图',
    page: '19',
    type: 1,
    url:'https://zxxb-oss.haibian.com/nova/coursewares/201901170014/index.html?cocos=1.7.3'
  },
  {
    img: 'game_02.png',
    title: '规律填写',
    page: '根据题目进行两两连线',
    page: '13',
    type: 2,

  },
  {
    img: 'game_03.png',
    title: '老虎机',
    page: '老师点击后随机出现题目，题目中有数字，钻石，炸弹',
    type: 3,

  },
  {
    img: 'game_04.png',
    title: '拖拽题',
    page: '拖拽到对应区域完成作答',
    type: 0,

  },
  {
    img: 'game_05.png',
    title: '大家来找茬',
    page: '开始游戏后根据题目点击对应的方块',
    type: 1,

  },
  {
    img: 'game_06.png',
    title: '点击合成题',
    page: '基础点击题，点击后执行动画',
    type: 1,

  },
  {
    img: 'game_07.png',
    title: '手指点击题',
    page: '点击后手指弯曲或者伸直',
    type: 1,

  },
  {
    img: 'game_08.png',
    title: '点击与拖拽并存',
    page: '点击手指正确并且拖拽题目正确时算答对',
    type: 1,

  },
  {
    img: 'game_09.png',
    title: '分组拖拽',
    page: '将答案放到对应区域后，区域出现缩小的图形',
    type: 1,

  },

  {
    img: 'game_10.png',
    title: '基础点击题',
    page: '点击后触发一些基本回调',
    type: 1,

  },
  {
    img: 'game_11.png',
    title: '转盘题',
    page: '滑动转盘选择正确答案，点击确定后停止转动',
    type: 1,

  },
  {
    img: 'game_12.png',
    title: '翻牌题',
    page: '开始牌子为正面，开始游戏后变为反面，同时学生点击两个对应的牌子，直到全部答对',
    type: 1,

  },
  {
    img: 'game_13.png',
    title: '瓢虫题',
    page: '根据题目选择两两对应的数字完成题目中的问题',
    type: 1,
  },
  {
    img: 'game_14.png',
    title: '卡车题',
    page: '根据题目,左边蘑菇代表十位,右边蘑菇代表各位,点击后对应卡车的位数增加,点击x清空,点击对勾提交',
    type: 1,
  },
  {
    img: 'game_50.png',
    title: '学一学',
    page: '播放学一学音效',
    type: 1,
  },
  {
    img: 'game_51.png',
    title: '课间休息',
    page: '播放课件休息音效，老师可以点上课，这时学生端将播放音乐',
    type: 1,
  },
]



// WEBPACK FOOTER //
// ./src/components/index/data.js